<template>
  <section class="common-race-points-card-parts">
    <h3 class="common-race-points-card-parts__title">
      <span>{{ cardTitle }}</span>
    </h3>

    <figure v-if="pointsCardData.thumbnail" class="common-race-points-card-parts__thumbnail">
      <img :src="pointsCardData.thumbnail" alt="" />
    </figure>

    <h4
      v-if="pointsCardData.catch"
      class="common-race-points-card-parts__catch"
      v-text="pointsCardData.catch[$i18n.locale]"
    />
    <p
      v-if="pointsCardData.text"
      class="common-race-points-card-parts__text"
      v-html="pointsCardData.text[$i18n.locale]"
    />

    <slot />

    <p v-if="pointsCardData.to">
      <atom-icon-router-button
        class="common-race-points-card-parts__lap-link"
        :to="pointsCardData.to"
        :linkText="$tc('RaceListPage.Information.play.thisLap')"
        theme="light"
        colorType="secondary"
        size="xxsmall"
        :imgPath="playIconPath"
      />
    </p>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import AtomIconRouterButton from '@/components/atoms/AtomIconRouterButton.vue'
import { RacePointVideoCardDataType } from '@/components/RaceListPage/hook/useRacePointVideo'
import { RacePointRadioDataType } from '@/store/stores/pageStore/TopPage/TopPageStore'

/* eslint-disable @typescript-eslint/no-var-requires */
const playIconPath = require('@/assets/img/icon/icon_play__green.svg')

/**
 * レース一覧画面: レース ポイント 共通カードコンポーネント
 */
export default defineComponent({
  name: 'CommonRacePointsCardParts.vue',
  components: {
    AtomIconRouterButton,
  },
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    pointsCardData: {
      type: Object as PropType<RacePointVideoCardDataType | RacePointRadioDataType>,
      required: true,
    },
  },
  setup() {
    return {
      playIconPath,
    }
  },
})
</script>

<style lang="scss" scoped>
.common-race-points-card-parts {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 20px 16px;
  gap: 16px;
  background: rgba($black, 0.2);
  border: 1px solid rgba($white, 0.3);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  color: $white;
  text-align: left;

  &__title {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: min(#{convertPXtoVW(14)}, 14px);
    font-family: $fontHeading;
    font-weight: 600;
    font-size: min(#{convertPXtoVW(18)}, 18px);
    line-height: 1.33;
    text-align: center;
    letter-spacing: 0.04em;

    &::after {
      display: block;
      content: '';
      width: 24px;
      height: 2px;
      margin: 0 auto;
      background: linear-gradient(
        84.94deg,
        $green-lighter -121.14%,
        $green-lighter -121.14%,
        rgba($green-lighter, 0.5) -80.24%,
        $green-lighter -34.6%,
        rgba($green-lighter, 0.5) 10.88%,
        $green-lighter 51.93%,
        rgba($green-lighter, 0.5) 91.87%
      );
    }
  }

  &__catch {
    width: 100%;
    font-weight: 700;
    font-size: min(#{convertPXtoVW(14)}, 14px);
    line-height: 1.54;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    text-align: left;
  }

  &__text {
    width: 100%;
    font-weight: 500;
    font-size: min(#{convertPXtoVW(11)}, 11px);
    line-height: 1.64;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    word-break: break-all;
    white-space: pre-line;
  }

  &__lap-link {
    margin-top: 4px;

    &--disabled {
      pointer-events: none;
    }
  }
}
</style>

<style lang="scss">
.common-race-points-card-parts {
  &__lap-link {
    .atom-icon-router-btn--has-icon {
      min-height: min(#{convertPXtoVW(30)}, 30px);
    }
  }
}
</style>
